var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["contentful/shoppable/shoppable-product-tag.j2"] = require( "contentful/shoppable/shoppable-product-tag.j2" );
dependencies["contentful/shoppable/shoppable-product-dot.j2"] = require( "contentful/shoppable/shoppable-product-dot.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/shoppable/shoppable-product-component.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "shoppableProduct"),"fields.productSlug"]));
frame.set("productSlug", t_1, true);
if(frame.topLevel) {
context.setVariable("productSlug", t_1);
}
if(frame.topLevel) {
context.addExport("productSlug", t_1);
}
var t_2;
t_2 = (lineno = 1, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "shoppableProduct"),"fields.colorCode"]));
frame.set("productColor", t_2, true);
if(frame.topLevel) {
context.setVariable("productColor", t_2);
}
if(frame.topLevel) {
context.addExport("productColor", t_2);
}
var t_3;
t_3 = (lineno = 2, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.deviceCharacteristics.is_smallish",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("isMobile", t_3, true);
if(frame.topLevel) {
context.setVariable("isMobile", t_3);
}
if(frame.topLevel) {
context.addExport("isMobile", t_3);
}
var t_4;
t_4 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_touch");
frame.set("isTouch", t_4, true);
if(frame.topLevel) {
context.setVariable("isTouch", t_4);
}
if(frame.topLevel) {
context.addExport("isTouch", t_4);
}
var t_5;
t_5 = (lineno = 5, colno = 46, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "shoppableProduct"),"fields.secondaryImageCoordinates"]));
frame.set("secondaryImageCoordinates", t_5, true);
if(frame.topLevel) {
context.setVariable("secondaryImageCoordinates", t_5);
}
if(frame.topLevel) {
context.addExport("secondaryImageCoordinates", t_5);
}
if(runtime.contextOrFrameLookup(context, frame, "secondaryImageCoordinates") && !runtime.contextOrFrameLookup(context, frame, "isMobile")) {
var t_6;
t_6 = runtime.contextOrFrameLookup(context, frame, "secondaryImageCoordinates");
frame.set("imageCoordinates", t_6, true);
if(frame.topLevel) {
context.setVariable("imageCoordinates", t_6);
}
if(frame.topLevel) {
context.addExport("imageCoordinates", t_6);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "isMobile")) {
var t_7;
t_7 = (lineno = 11, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "shoppableProduct"),"fields.primaryImageCoordinates"]));
frame.set("imageCoordinates", t_7, true);
if(frame.topLevel) {
context.setVariable("imageCoordinates", t_7);
}
if(frame.topLevel) {
context.addExport("imageCoordinates", t_7);
}
;
}
;
}
var t_8;
t_8 = (lineno = 14, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "imageCoordinates"),"fields.xCoordinate"]));
frame.set("xCoordinate", t_8, true);
if(frame.topLevel) {
context.setVariable("xCoordinate", t_8);
}
if(frame.topLevel) {
context.addExport("xCoordinate", t_8);
}
var t_9;
t_9 = (lineno = 15, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "imageCoordinates"),"fields.yCoordinate"]));
frame.set("yCoordinate", t_9, true);
if(frame.topLevel) {
context.setVariable("yCoordinate", t_9);
}
if(frame.topLevel) {
context.addExport("yCoordinate", t_9);
}
var t_10;
t_10 = runtime.contextOrFrameLookup(context, frame, "xCoordinate") && runtime.contextOrFrameLookup(context, frame, "yCoordinate");
frame.set("imageHasCoordinates", t_10, true);
if(frame.topLevel) {
context.setVariable("imageHasCoordinates", t_10);
}
if(frame.topLevel) {
context.addExport("imageHasCoordinates", t_10);
}
var t_11;
t_11 = (runtime.contextOrFrameLookup(context, frame, "isMobile")?"dot":"tag");
frame.set("shoppableEventType", t_11, true);
if(frame.topLevel) {
context.setVariable("shoppableEventType", t_11);
}
if(frame.topLevel) {
context.addExport("shoppableEventType", t_11);
}
if(runtime.contextOrFrameLookup(context, frame, "imageHasCoordinates")) {
var t_12;
t_12 = "left:" + "" + runtime.contextOrFrameLookup(context, frame, "xCoordinate") + "" + "%" + "" + ";" + "" + "top:" + "" + runtime.contextOrFrameLookup(context, frame, "yCoordinate") + "" + "%";
frame.set("shoppableProductPositions", t_12, true);
if(frame.topLevel) {
context.setVariable("shoppableProductPositions", t_12);
}
if(frame.topLevel) {
context.addExport("shoppableProductPositions", t_12);
}
output += "<div>\n        <a\n            href=\"#\"\n            class=\"c-shoppable-image__product js-launch-shoppable-quickshop\"\n            data-shoppable-product-slug=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "productSlug"), env.opts.autoescape);
output += "\"\n            data-shoppable-product-color=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "productColor"), env.opts.autoescape);
output += "\"";
if(runtime.contextOrFrameLookup(context, frame, "imageHasCoordinates")) {
output += "style=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "shoppableProductPositions"), env.opts.autoescape);
output += "\"";
;
}
output += runtime.suppressValue((lineno = 30, colno = 15, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","shopitorial " + "" + runtime.contextOrFrameLookup(context, frame, "shoppableEventType") + "" + " click",runtime.contextOrFrameLookup(context, frame, "productSlug")])), env.opts.autoescape);
output += "\n            tabindex=\"0\"\n        >\n\n            ";
if(!runtime.contextOrFrameLookup(context, frame, "isTouch")) {
output += "\n                ";
env.getTemplate("contentful/shoppable/shoppable-product-tag.j2", false, "core/templates/contentful/shoppable/shoppable-product-component.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n            ";
})});
}
output += "\n\n            ";
env.getTemplate("contentful/shoppable/shoppable-product-dot.j2", false, "core/templates/contentful/shoppable/shoppable-product-component.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n\n        </a>\n    </div>";
})});
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/shoppable/shoppable-product-component.j2"] , dependencies)